import api from '@/utils/axios';

function assertSuccess(response, fallbackMessage) {
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || fallbackMessage);
  }
  return response.data;
}

export async function acquireEditLock(resourceKey) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('common/acquireLock', { token, resourceKey });
  const data = assertSuccess(response, 'Failed to acquire edit lock');
  return data.data || {};
}

export async function releaseEditLock(resourceKey) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('common/releaseLock', { token, resourceKey });
  const data = assertSuccess(response, 'Failed to release edit lock');
  return data.data || {};
}

export async function fetchFreshness() {
  const token = localStorage.getItem('srToken');
  const response = await api.post('common/freshness', { token });
  const data = assertSuccess(response, 'Failed to check freshness');
  return data.data || {};
}
